import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'
import { Marquee } from '@/components/generals/marquee'
import { LiveDot } from '@/components/generals/live-dot'
import { heroTicker } from '@/constants/home'

const TickerLine: FC = (): ReactNode => {
    return (
        <span className='flex items-center gap-5 whitespace-nowrap'>
            <LiveDot pulse={false} />

            {heroTicker.map((item, index) => (
                <Fragment key={item}>
                    {index > 0 && (
                        <span aria-hidden='true' className='text-white/25'>
                            /
                        </span>
                    )}

                    <span>
                        {item}
                    </span>
                </Fragment>
            ))}
        </span>
    )
}

/** Control-room ticker along the bottom of the hero. Scrolls slowly and pauses on hover. */
export const LiveTicker: FC = (): ReactNode => {
    return (
        <div className='relative bg-ink'>
            <p className='sr-only'>
                {heroTicker.join(', ')}
            </p>

            <div aria-hidden='true'>
                <Marquee
                    speed={34}
                    hoverFactor={0}
                    copies={3}
                    trackClassName='eyebrow gap-14 py-4 pr-14 text-[11.5px] text-white/75'
                >
                    <TickerLine />
                    <TickerLine />
                </Marquee>
            </div>
        </div>
    )
}
